import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../../global.css';
import RuntimePropertySearchHealthScorePage from './pages/RuntimePropertySearchHealthScorePage';
import RuntimeHealthScorePage from './pages/RuntimeHealthScorePage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

interface AppProps {
  basePath?: string;
  showEmailConfirmModal?: boolean;
}

const App: React.FC<AppProps> = ({ basePath = '', showEmailConfirmModal = true }) => {
  // Ensure basePath starts with a / if provided and not empty
  const normalizedBasePath = basePath
    ? basePath.startsWith('/') ? basePath : `/${basePath}`
    : '';

  // Root path for redirects
  const rootPath = normalizedBasePath || '/';

  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        {/* If basePath is empty, this becomes just <Route path=""> which matches the root */}
        <Route path={normalizedBasePath}>
          <Route
            index
            element={<RuntimePropertySearchHealthScorePage />}
          />
          <Route
            path="property/:propertyId"
            element={<RuntimeHealthScorePage showEmailConfirmModal={showEmailConfirmModal} />}
          />
        </Route>
        <Route
          path="*"
          element={<Navigate to={rootPath} replace />}
        />
      </Routes>
    </QueryClientProvider>
  );
};

export default App;